var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusculoSkeletal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.403 128.004V161.893",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.597 128.004V161.893",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.704 94.3725L110.291 89.1076L101.218 94.6145C96.7304 97.3387 90.9897 94.1074 90.9897 88.8575V63.4582C90.9897 57.5681 95.7649 52.793 101.655 52.793H118.346C124.236 52.793 129.011 57.5681 129.011 63.4582V88.6637C129.011 93.9553 123.189 97.1797 118.704 94.3725Z",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.011 75.2891C129.011 80.5802 123.189 83.8046 118.704 80.9979L110.291 75.7329L101.218 81.2398C96.7304 83.964 90.9897 80.7328 90.9897 75.4829",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.974 62.5582C128.974 62.5625 128.974 62.5625 128.974 62.5668C128.45 67.4046 122.973 70.1993 118.705 67.5249L110.292 62.2578L101.221 67.7655C96.9199 70.3755 91.4723 67.5211 91.0259 62.6617",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.697 52.7969H131.849C134.316 52.7969 136.614 54.0498 137.95 56.1239L152.308 79.6811C153.602 81.6912 154.445 83.9582 154.778 86.3258L159.411 119.29L165.968 128.012",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5878 119.289L54.0308 128.01",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.303 52.7969H88.1504C85.6835 52.7969 83.3856 54.0498 82.0497 56.1239L67.6917 79.6811C66.397 81.6912 65.554 83.9582 65.2214 86.3258L62.6841 104.38",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41.5V112.547",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M110 112.544V122.792L103.076 127.192C100.708 128.697 97.5753 128.061 95.9808 125.754L88.5497 114.998C86.9174 112.635 87.6895 109.379 90.2088 108C91.3539 107.374 92.704 107.236 93.9518 107.619L110 112.544Z",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110 112.544V122.792L116.924 127.192C119.292 128.697 122.424 128.061 124.019 125.754L131.45 114.998C133.082 112.635 132.31 109.379 129.791 108C128.646 107.374 127.296 107.236 126.048 107.619L110 112.544Z",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.551 115.004V163.43C88.551 166.544 89.7326 169.543 91.8579 171.82C93.9827 174.097 95.1647 177.096 95.1647 180.211V213.286C95.1647 215.216 93.6003 216.781 91.6701 216.781H70.8853",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.451 151.047V163.433C131.451 166.547 130.269 169.546 128.144 171.823C126.019 174.1 124.837 177.099 124.837 180.214V213.289C124.837 215.219 126.401 216.784 128.332 216.784H149.116",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.451 115.004V135.983",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3496 18.8732V26.5113C94.3496 30.745 97.782 34.1773 102.016 34.1773V38.2087C102.016 40.0267 103.489 41.5005 105.307 41.5005H114.693C116.511 41.5005 117.985 40.0267 117.985 38.2087V34.1773C122.219 34.1773 125.651 30.745 125.651 26.5113V18.8732C125.651 10.2296 118.644 3.22266 110 3.22266C101.357 3.22266 94.3496 10.2296 94.3496 18.8732Z",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9922 63.4609L77.9048 84.7073",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.014 63.4609L142.101 84.7073",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.332 216.782V187.012",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6694 216.782V187.012",
    stroke: "#7f56d9",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusculoSkeletal);
export default __webpack_public_path__ + "static/media/musculoSkeletal.b600e081c56df57a3cdde16ec9810e17.svg";
export { ForwardRef as ReactComponent };